export default {
  triggerButtonText: '{type} New Order',
  toast: {
    title: 'Orders created',
  },
  form: {
    orderInventory: {
      orderTotal: 'Order Total',
      orderTotalIncludingVAT: 'Total Incl VAT',
      vendorWithVATNote: 'VAT registered vendors will have their VAT % added to their total price',
    },
  },
  // TODO: Remove legacy order translation when orders and claims views, tables and forms have been fully separated
  legacyForm: {
    project: {
      placeholder: 'Select a project',
      label: 'Project',
    },
    site: {
      placeholder: 'Select a site',
      label: 'Site',
    },
    deliveryDate: 'Delivery date',
    notes: 'Notes',
  },
  orderDetailsSection: {
    title: '{type} Details',
    subtitle: 'Complete the {type} details below. *Required field',
  },
  orderInventorySection: {
    title: '{type} Inventory',
    subtitle:
      'Individual {type}s will be placed for the below items at each of the included vendors',
    noResults: 'No Results',
    variation: 'Variation',
    addLineItem: 'Add new line item',
    itemHasVariation:
      'This item has a pending variation that needs to be approved or denied before it can be added to your cart.',
    table: {
      noItems:
        'Select a site above before adding items to your order inventory. To order items not assigned to a specific site, create a new site for General or Head Office to assign purchases for your organization.',
      orderSubtotal: 'Order Subtotal',
      orderTotal: 'Order Total',
      vatInfoText:
        'VAT registered vendors will have their allocated VAT % added to their total price',
      search: 'Search by line item name or spec (Esc to close)',
      addNewSection: '+ Add new section',
      columns: {
        type: 'Type',
        section: 'BOQ section',
        unit: 'Unit',
        qty: 'Qty',
        rate: 'Rate',
        total: 'Total',
        approved: 'BOQ approved',
        ordered: 'Ordered',
        mobileQtyHeader: 'Qty Delivered',
        mobileCombinedHeader: 'Item/Spec/Sku',
      },
    },
    toasts: {
      itemInCart: {
        title: 'Item in cart',
        content: 'This item is already in your cart',
      },
    },
  },
  createRequests: 'Create request(s)',
  clearCart: 'Clear cart',
  next: 'Next',
  orderRequests: {
    table: {
      add: 'Add',
      edit: 'Edit',
      NA: 'NA',
      headers: {
        requestType: 'Request type',
        vendor: 'Vendor',
        amount: 'Amount',
        deposits: 'Deposits',
        deductions: 'Deductions',
      },
      depositsInfo:
        'will separate the approved orders payment requests into two parts. A deposit request and a payment request for the outstanding amount.',
      additionsInfo: 'Deposits and retentions can be added to a claim.',
      additionsInfoRetention: 'will create a separate Retention payment to the vendor.',
      methodsInfo: 'sets what the payment priority for this order will be:',
      methodsInfoCod: 'Cash on Delivery payments are paid before the set due date.',
      methodsInfoAccount: 'Account payments are paid when vendor accounts are settled.',
      methodsInfoDeposit: 'Deposit payments are paid before the order delivery date.',
      deductionsInfo:
        'Deductions can be added to any claims requests being submitted for approval. Deductions include any retention payments or contra charges for this vendors.',
      depositExceedsTotal: 'Deposit exceeds total order / claim amount',
      noDeposits:
        'Deposits cannot be added when the overall order or claim amount will be negative or 0.',
    },
    loseInfoModal: {
      title: 'Lose Information',
      content:
        'If you leave this page, any information you`ve entered will be lost. Are you sure you want to leave?',
      confirm: 'Yes, leave',
    },
    deductions: {
      deductions: 'Deductions',
      claim: 'Claim',
      title: 'Add Deductions',
      retentions: {
        detailsUpdateSuccess: {
          title: '{type} updated',
          content: 'Retention details have been updated',
        },
      },
      itemContraCharges: {
        detailsUpdateSuccess: {
          title: '{type} updated',
          // What the toast names when the caller doesn't say which field it committed — the
          // pre-rework tables send the whole charge up on any edit and have no single field to name.
          fallbackType: 'Item contra charge',
          content: 'Item contra charge details have been updated',
        },
      },
      valueContraCharges: {
        overClaimTotal: 'Exceeds total claim amount',
        detailsUpdateSuccess: {
          title: '{type} updated',
          fallbackType: 'Value contra charge',
          content: 'Value contra charge details have been updated',
        },
      },
      claimSubtotal: 'Claim Subtotal',
      totalInclVat: 'Total Incl VAT',
      vatRegistered:
        'VAT registered vendors will have their allocated VAT % added to their total price',
      confirm: 'Confirm Deductions',
    },
  },
};
